import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useAuth } from '../../hooks/useAuth';

type Mode = 'login' | 'register';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState<Mode>('login');
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!form.phone || !form.password) {
      setError('يرجى ملء جميع الحقول');
      return;
    }
    if (mode === 'register' && !form.name) {
      setError('يرجى إدخال اسمك');
      return;
    }
    setLoading(true);
    await new Promise(r => setTimeout(r, 800));
    login({ name: form.name || 'عميل مميز', phone: form.phone, email: form.email });
    setLoading(false);
    navigate('/');
  };

  return (
    <main>
      <Navbar />
      <section className="min-h-screen pt-20 pb-20 px-6 flex items-center justify-center bg-[#F5F1E8]">
        <div className="w-full max-w-xl">
          {/* Card */}
          <div className="bg-white rounded-3xl overflow-hidden">
            {/* Header Image */}
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/3a1cbeae22667c96dbc65367d7361bb4.jpg"
                alt="خلفية تسجيل الدخول"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
                <div>
                  <img
                    src="https://public.readdy.ai/ai/img_res/196e3761-b52b-4536-9200-ac860c5863e1.png"
                    alt="شعار"
                    className="h-10 w-auto object-contain mb-2"
                  />
                </div>
              </div>
            </div>

            <div className="p-8">
              {/* Toggle */}
              <div className="flex items-center bg-[#F5F1E8] rounded-full p-1 mb-8">
                <button
                  onClick={() => setMode('login')}
                  className={`flex-1 py-2.5 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                    mode === 'login' ? 'bg-white text-[#C9A961]' : 'text-gray-500'
                  }`}
                >
                  تسجيل الدخول
                </button>
                <button
                  onClick={() => setMode('register')}
                  className={`flex-1 py-2.5 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                    mode === 'register' ? 'bg-white text-[#C9A961]' : 'text-gray-500'
                  }`}
                >
                  حساب جديد
                </button>
              </div>

              <h2 className="text-2xl font-black text-gray-900 text-center mb-8">
                {mode === 'login' ? 'مرحباً بعودتك!' : 'أنشئ حسابك'}
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                {mode === 'register' && (
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5">الاسم الكامل</label>
                    <div className="relative">
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                        <i className="ri-user-line text-gray-400" />
                      </div>
                      <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="اسمك الكامل"
                        className="w-full pr-10 pl-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A961]/30 text-right"
                      />
                    </div>
                  </div>
                )}

                {mode === 'register' && (
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5">البريد الإلكتروني</label>
                    <div className="relative">
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                        <i className="ri-mail-line text-gray-400" />
                      </div>
                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="example@email.com"
                        className="w-full pr-10 pl-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A961]/30 text-right"
                      />
                    </div>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">رقم الهاتف / واتساب</label>
                  <div className="relative">
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                      <i className="ri-smartphone-line text-gray-400" />
                    </div>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="+971XXXXXXXXX"
                      className="w-full pr-10 pl-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A961]/30 text-right"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">كلمة المرور</label>
                  <div className="relative">
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                      <i className="ri-lock-line text-gray-400" />
                    </div>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      className="w-full pr-10 pl-12 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A961]/30 text-right"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center cursor-pointer text-gray-400 hover:text-gray-600"
                    >
                      <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'} />
                    </button>
                  </div>
                </div>

                {mode === 'login' && (
                  <div className="flex justify-between items-center">
                    <a href="#" rel="nofollow" className="text-[#C9A961] text-sm hover:underline cursor-pointer">
                      نسيت كلمة المرور؟
                    </a>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" className="rounded" />
                      <span className="text-gray-500 text-sm">تذكرني</span>
                    </label>
                  </div>
                )}

                {error && (
                  <div className="p-3 bg-red-50 rounded-xl">
                    <p className="text-red-500 text-sm text-center">{error}</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#C9A961] text-white py-4 rounded-xl font-bold text-base hover:bg-[#A07C30] transition-colors cursor-pointer disabled:opacity-70 whitespace-nowrap mt-2"
                >
                  {loading ? 'جاري التحميل...' : mode === 'login' ? 'تسجيل الدخول' : 'إنشاء الحساب'}
                </button>
              </form>

              {/* Back to home */}
              <div className="text-center mt-6">
                <Link
                  to="/"
                  className="text-gray-400 text-sm hover:text-gray-600 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line ml-1" />
                  العودة للرئيسية
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
